/**
 * アプリの絵文字アイコンの出し方の値。サーバー（/api/ui-glyphs）と画面（glyph-mode.ts）の両方で使うので、React を読まない。
 * line＝線のアイコン（下のナビと同じ線・既定）／none＝出さない。絵文字そのものは出さない（前の値 emoji は line として読む）。
 * 管理UIの local-ui/src/types/ui-glyphs.ts と同じ値
 */
export const GLYPH_MODES = ["line", "none"] as const;
export type GlyphMode = (typeof GLYPH_MODES)[number];

export const isGlyphMode = (v: unknown): v is GlyphMode => typeof v === "string" && (GLYPH_MODES as readonly string[]).includes(v);
